export const destructUrlPattern = '/:appName?/:path';
